<template>
    <div class="container-fluid">
        <div class="d-flex justify-content-center mt-3" style="margin-bottom: 60px !important">
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <button class="btn btn-secondary" @click="printReport()"><i class="far fa-file-pdf"></i> PDF</button>
                <div class="accordion mt-2" id="accordionExample">
                    <div class="card" v-for="item in report" :key="item.s_id">
                        <div class="card-header bg-info" id="headingOne">
                            <h2 class="mb-0">
                                <button class="btn btn-block text-left collapsed text-white" type="button" data-toggle="collapse" :data-target="'#Collapse'+item.s_id" aria-expanded="true" :aria-controls="item.s_id">
                                    <span class="pl-0">{{item.s_rumiName}}</span>
                                    <span class="badge ml-1" :class="item.attendance.percent >= 70 ? 'badge-success' : 'badge-danger' ">[{{item.attendance.percent}} %]</span>
                                    <span class="float-right badge badge-success ml-1">{{item.attendance.hadir}}</span>
                                    <span class="float-right badge badge-danger ml-1">{{item.attendance.ghaib}}</span>
                                    <span class="float-right badge badge-warning ml-1">{{item.attendance.uzur}}</span>
                                </button>
                            </h2>
                        </div>
                        <div :id="'Collapse'+item.s_id" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body">
                                <ul>
                                    <div class="row">
                                        <div class="float-left font-weight-bold">Pensyarah : {{item.t_fnameRumi | upText}} {{item.t_lnameRumi | upText}}</div>
                                    </div>
                                    <div class="row" v-if="is_leader">
                                        <div class="float-left font-weight-bold">Telpon : {{item.t_telephone}}</div>
                                    </div>
                                    <li>
                                        <div class="float-left">Hadir</div>
                                        <div class="float-right">{{item.attendance.hadir}}</div>
                                    </li>
                                    <li>
                                        <div class="float-left">Ghaib</div>
                                        <div class="float-right">{{item.attendance.ghaib}}</div>
                                    </li>
                                    <li>
                                        <div class="float-left">Uzur</div>
                                        <div class="float-right">{{item.attendance.uzur}}</div>
                                    </li>
                                    <li>
                                        <div class="float-left font-weight-bold">Semua</div>
                                        <div class="float-right">{{item.attendance.total}}</div>
                                    </li>
                                    <div>
                                        <div class="float-left"></div>
                                        <div class="float-right">
                                            <router-link to="/attendanceDetail">
                                                <button @click="attendanceDetail(item.rs_id)" class="btn btn-success btn-sm mt-3 mb-3"><i class="fa fa-arrow-circle-right"></i></button>
                                            </router-link>
                                        </div>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/services/BackendService'
    export default {
        mounted(){
            this.retreiveAttendance()
        },
        data(){
            return{
                report: [],
                is_leader: ''
            }
        },
        methods:{
            printReport(){
                window.open(`${process.env.VUE_APP_URL_COOKIE}learning/printReportAttendancePdf`);
            },
            attendanceDetail(s_id){
                localStorage.setItem("attendance_detail_s_id", s_id)
            },
            retreiveAttendance(){
                this.$Progress.start()
                http.get(`learning/retreiveAttendance`)
                    .then(response => {
                        this.report = response.data.report
                        this.is_leader = response.data.is_leader
                        this.$Progress.finish()
                    })
                    .catch(error => {
                        if(error.response.status == 401 || error.response.status == 419){
                            this.$store.dispatch("authentication/cencelAuthen")
                        }
                        this.$Progress.fail()
                    })
            }
        } 
    }
</script>

<style lang="scss" scoped>

</style>